export enum EVisitationUrl {
  VISITATIONS = 'visitations',
  REJECT = 'reject',
  APPROVE = 'approve',
}
